import { Component, inject } from '@angular/core';
import { ApiPoll, PollsApi } from '@tytapp/api';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface PollBlock extends ContentBlock {
    pollId: string;
    full?: boolean;
}

@Component({
    template: `
        <tyt-poll [mini]="!block.full" *ngIf="poll" [poll]="poll"></tyt-poll>
    `
})
export class ViewComponent extends ContentBlockViewComponent<PollBlock> {
    private pollsApi = inject(PollsApi);

    poll: ApiPoll;

    async ngOnInit() {
        if (this.block.pollId === '<preview>') {
            let petitions = await this.pollsApi.all('published', 'ChooseOnePoll').toPromise();
            this.poll = petitions[0];
        } else {
            try {
                this.poll = await this.pollsApi.getPoll(this.block.pollId).toPromise();
            } catch (e) {
                console.error(`[PetitionBlock] No such petition ${this.block.pollId}`);
            }
        }
    }
}

@Component({
    template: `
        <mat-form-field>
            <mat-label>Enter Poll ID/Slug</mat-label>
            <input name="pollId" type="text" matInput [(ngModel)]="block.pollId"  [disabled]="locked" />
        </mat-form-field>
        <mat-checkbox [(ngModel)]="block.full">Show full poll</mat-checkbox>
    `,
    styles: [
        `
        mat-form-field {
            width: 100%;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<PollBlock> {
}

export const POLL_BLOCK_TYPE: ContentBlockType<PollBlock> = {
    id: 'poll',
    label: 'Poll',
    icon: 'ballot',
    preview: {
        pollId: '<preview>'
    },
    previewSettings: {
        fade: true
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
